import { ItemIdModel } from './../filter-model/item-id-model';
import { MasterHelper } from './../../utilities/master-helper';
import { PublishRegulationRespose } from './publish-regulation-response';

export class PublishRegulationFilter {
  title: string;
  reportDate: Date;
  reportFilter: Array<ReportFilterModel>;
  isId: boolean;
  isDescription: boolean;
  isStatus: boolean;
  isActionedBy: boolean;
  isEffectiveDate: boolean;
  isAssessor: boolean;
  selectedIdList: Array<number>;
  startDate: Date;
  endDate: Date;
  isDateRange: boolean;

  constructor() {
    this.title = '';
    this.reportDate = MasterHelper.getDate(0);
    this.reportFilter = [];
    this.isId = true;
    this.isDescription = true;
    this.isStatus = true;
    this.isActionedBy = true;
    this.isEffectiveDate = true;
    this.isAssessor = true;
    this.selectedIdList = [];
    this.startDate = MasterHelper.getDate(0);
    this.endDate = MasterHelper.getDate(90);
    this.isDateRange = false;
  }
}

export class ReportFilterModel {
  header: string;
  isDeleted: boolean;
  libraries: Array<ItemIdModel>;

  constructor() {
    this.header = '';
    this.isDeleted = false;
    this.libraries = [];
  }
}

export class PublishReportResponse {
  title: string;
  reportDate: Date;
  reportData: Array<ReportDataModel>;
  isId: boolean;
  isDescription: boolean;
  isStatus: boolean;
  isActionedBy: boolean;
  isEffectiveDate: boolean;
  isAssessor: boolean;

  constructor() {
    this.title = '';
    this.reportDate = MasterHelper.getDate(0);
    this.reportData = [];
    this.isId = true;
    this.isDescription = true;
    this.isStatus = true;
    this.isActionedBy = true;
    this.isEffectiveDate = true;
    this.isAssessor = true;
  }
}

export class ReportDataModel {
  header: string;
  regulations: Array<PublishRegulationRespose>;

  constructor() {
    this.header = '';
    this.regulations = [];
  }
}
